<div *ngIf="blog" class="card blog-card mb-4" [routerLink]="['/blog/post', blog.slug]" style="cursor: pointer">
  <div *ngIf="blog.main_image" class="card-image-top pt-1" alt="{{blog.title}}">
    <img [src]="blog.main_image" class="img img-responsive mw-100" loading="lazy">
  </div>
  <div class="card-body">
    <h5 class="card-title">
      <a [routerLink]="['/blog/post', blog.slug]">{{blog.title}}</a>
    </h5>
    <div class="card-tags d-inline-flex w-100">
      <p class="flex">
        {{blog.author_name}}
      </p>
      <p class="flex">
        {{blog.updated_at | date: 'mediumDate'}}
      </p>
      <p class="flex">
        Tags
      </p>
      <!-- <a class="read-more flex ms-auto" *ngIf="blog.body" [routerLink]="['/blog/post', blog.slug]">Read More...</a> -->
    </div>
    <div class="card-blog-body" *ngIf="blog.body" [innerHtml]="blog.body | safeHtml">
    </div>
    <!-- <a class="read-more" *ngIf="blog.body" [routerLink]="['/blog/post', blog.slug]">Read More...</a> -->
  </div>
  <div class="card-footer">
    <a class="read-more" *ngIf="blog.body" [routerLink]="['/blog/post', blog.slug]">Read More...</a>
  </div>
</div>
